/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalEntityResultResource
 */
export interface LegalEntityResultResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    companyIdentityId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    vatIdentificationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    registrationOfficeInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResultResource
     */
    addressCountryCode?: string;
    /**
     * True when the legal entity has been archived (archival_date is set). Not filterable.
     * @type {boolean}
     * @memberof LegalEntityResultResource
     */
    archived: boolean;
}

/**
 * Check if a given object implements the LegalEntityResultResource interface.
 */
export function instanceOfLegalEntityResultResource(value: object): value is LegalEntityResultResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('archived' in value) || value['archived'] === undefined) return false;
    return true;
}

export function LegalEntityResultResourceFromJSON(json: any): LegalEntityResultResource {
    return LegalEntityResultResourceFromJSONTyped(json, false);
}

export function LegalEntityResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'companyIdentityId': json['companyIdentityId'] == null ? undefined : json['companyIdentityId'],
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'vatIdentificationNumber': json['vatIdentificationNumber'] == null ? undefined : json['vatIdentificationNumber'],
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'addressCountryCode': json['addressCountryCode'] == null ? undefined : json['addressCountryCode'],
        'archived': json['archived'],
    };
}

export function LegalEntityResultResourceToJSON(value?: LegalEntityResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'companyIdentityId': value['companyIdentityId'],
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'vatIdentificationNumber': value['vatIdentificationNumber'],
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'formattedAddress': value['formattedAddress'],
        'addressCountryCode': value['addressCountryCode'],
        'archived': value['archived'],
    };
}

